// this prevents the theme from switching before the page has transitioned
// see PageLoader.vue for the SSR head/theme/gtm update
// TODO: @frankd, nice try but this doesn't work, leaving this for the last sprint.
import { usePageStore } from '~/store/page'

export const useTheme = () => {
  const pageStore = usePageStore()
  const headData = {
    htmlAttrs: {
      'data-domain': `${pageStore.getCurrentPage?.domain?.color?.name}`
    }
  }
  return useHead(headData)
}
